import React, { useContext, useState, useEffect } from 'react';
import { RicosContext, PluginsContext, ModalContext, EditorContext } from 'ricos-context';
import ImageSettings from '../toolbar/image-settings.js';
import { IMAGE_TYPE } from '../types.js';
import { imageModals } from '../consts.js';
import { SPOILER_TYPE, TIPTAP_IMAGE_TYPE } from 'ricos-content';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-common/libs/imageUtils';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ImageSettingsModal = ({ nodeId }) => {
  const { theme, t, isMobile, languageDir, experiments } = useContext(RicosContext);
  const plugins = useContext(PluginsContext);
  const spoilerPlugin = plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
  const shouldShowSpoiler = spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(IMAGE_TYPE));
  const modalService = useContext(ModalContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const [initialData, setInitialData] = useState();
  const [componentData, setComponentData] = useState();
  const [converters, setConverters] = useState({});
  useEffect(() => {
    import(
      /* webpackChunkName:"ricos-converters" */
      'ricos-converters'
    ).then((convertersModule) => {
      const { draftBlockDataToTiptap, tiptapNodeDataToDraft } = convertersModule;
      setConverters({ tiptapNodeDataToDraft, draftBlockDataToTiptap });
      const componentData2 = tiptapNodeDataToDraft(
        TIPTAP_IMAGE_TYPE,
        getEditorCommands().getBlockComponentData(nodeId)
      );
      setInitialData(componentData2);
      setComponentData(componentData2);
    });
  }, []);
  const updateData = (data) => {
    var _a;
    getEditorCommands().setBlock(nodeId, IMAGE_TYPE, __spreadProps(__spreadValues({}, (_a = converters.draftBlockDataToTiptap) == null ? void 0 : _a.call(converters, IMAGE_TYPE, __spreadValues(__spreadValues({}, componentData), data))), {
      id: nodeId
    }));
    setComponentData(__spreadValues(__spreadValues({}, componentData), data));
  };
  const closeModal = () => {
    modalService.closeModal(imageModals.settings);
  };
  const onCancel = () => {
    updateData(initialData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    ImageSettings,
    {
      componentData,
      helpers: {},
      experiments,
      theme,
      t,
      isMobile,
      languageDir,
      onCloseRequested: closeModal,
      updateData,
      shouldShowSpoiler,
      onSave: closeModal,
      onCancel
    }
  ) : null;
};

export { ImageSettingsModal as default };
//# sourceMappingURL=SettingsModal.js.map
